import React from 'react';
import { SubdomainLink } from '../components/SubdomainLink';

const Unauthorized = () => {
  return (
    <div className="min-h-[70vh] bg-slate-950 flex items-center justify-center p-6 relative overflow-hidden select-none">
      {/* Background gradients */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#2ab391] opacity-20 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-emerald-500 opacity-10 rounded-full blur-[150px] pointer-events-none"></div>
      
      <div className="relative max-w-md w-full text-center bg-white/5 backdrop-blur-md border border-white/10 p-8 rounded-2xl shadow-2xl">
        <div className="w-20 h-20 bg-red-500/10 border border-red-500/20 text-red-400 rounded-full flex items-center justify-center mx-auto mb-6 shadow-[0_0_50px_rgba(239,68,68,0.1)]">
          <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-extrabold text-white tracking-tight mb-2">Access Denied</h1>
        <p className="text-slate-400 mb-8 font-medium">
          You do not have the required administrative permissions to access this page. Please contact the system administrator if you believe this is an error.
        </p>
        
        <SubdomainLink 
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-semibold rounded-lg text-white bg-[#2ab391] hover:bg-[#23977a] active:scale-[0.98] transition-all duration-200 shadow-lg shadow-[#2ab391]/25"
        >
          Go Back Home
        </SubdomainLink>
      </div>
    </div>
  );
};

export default Unauthorized;
